import React from "react"
import useDisclosure from "hooks/useDisclosure"
import { t } from "i18next"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useQuery } from "@tanstack/react-query"
import { getEmployees } from "api/employeeApi"
import HandleError from "components/Common/HandleError"
import SearchInput from "components/Common/SearchInput"
import Paginate from "components/Common/Paginate"
import useParamsQuery from "hooks/useParamsQuery"
import useInitialData from "hooks/useInitialData"
import EmployeeRow from "./EmployeeRow"
import CreateEmployeeModal from "./CreateEmployeeModal"

export default function EmployeesTable() {
  const createModal = useDisclosure()
  const { params, addParam, deleteParam } = useParamsQuery()
  const { data, isLoading, error } = useQuery({
    queryKey: ["employees", params],
    queryFn: () => getEmployees(params),
  })
  const { results, count } = useInitialData(data)

  const onSearch = value => {
    value ? addParam({ fullname: value }) : deleteParam("fullname")
  }

  return (
    <React.Fragment>
      <CreateEmployeeModal
        isOpen={createModal.isOpen}
        toggle={createModal.toggle}
      />
      <Card>
        <CardBody>
          <div className="space-between gap-3">
            <SearchInput onSearch={onSearch} defaultValue={params.name} />
            <Button color="primary" onClick={createModal.open}>
              {t("create employee")}
            </Button>
          </div>
          <div className="table-responsive my-3">
            <Table className="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>{t("full name")}</th>
                  <th>{t("phone")}</th>
                  <th>{t("email")}</th>
                  <th>{t("joining date")}</th>
                  <th className="col-w-sm">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {results.map(user => {
                  return <EmployeeRow key={user.id} userData={user} />
                })}
              </tbody>
            </Table>
            <HandleError
              isLoading={isLoading}
              error={error}
              isEmpty={!results.length}
            />
          </div>

          <div className="d-flex align-items-center justify-content-end ">
            <Paginate
              count={count}
              size={params.size || 10}
              forcePage={+params.page || 1}
              onPageChange={page => addParam({ page: page.selected + 1 })}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
